
import {of as observableOf,  Observable } from 'rxjs';
import {
    AsyncValidatorFn,
    AbstractControl,
    ValidationErrors,
    FormControl,
    FormGroup,
    Validators
} from "@angular/forms";

import * as jp from "jsonpath/jsonpath";
import { Note } from "../../common/models/note.model";
import StaticPromise from "../../common/models/static-promise";
import { QuestionKind, ButtonKind, ButtonPosition, SideEffectType, ValidationRule, StateType, PageType, DetailedFlowHistory, FlowIndex } from "../../common/models/flow.dto";
import { WorkOrder, WorkOrderWithAssignments, WorkOrderStatus } from "../../common/models/work-order.model";
//import { FlowPermitPdfGeneratorComponent } from "../../form-controls/components/flow-permit-pdf-generator/flow-permit-pdf-generator.component";
export { QuestionKind, ButtonKind, ButtonPosition, SideEffectType, StateType, PageType, WorkOrder, WorkOrderWithAssignments };

export class FlowInstance {
    name?: string;
    templateId: string;
    templateName: string;
    clarificationNotes?: Note[];
    context: any;
    id: string;
    previousState: string | null;
    organizationId: string | null;
    userId: string | null;
    currentState: string;
    currentWorkItem: string;
    associatedWorkItems: Array<WorkOrderWithAssignments>;
    states: State[];
    history: Array<DetailedFlowHistory>;
    isPublic: boolean;
    startAtSummary: boolean;
    onBehalf: boolean;
    isReturned: boolean;
    constructor(args: {
        name?: string,
        context?: any,
        id?: string,
        templateId?: string,
        templateName?: string;
        organizationId?: string,
        userId?: string,
        previousState?: string,
        currentState?: string,
        states?: State[],
        currentWorkItem: string,
        associatedWorkItems: Array<WorkOrderWithAssignments>,
        history?: Array<DetailedFlowHistory>,
        isPublic: boolean,
        startAtSummary: boolean,
        onBehalf?: boolean,
        isReturned?: boolean
    }) {
        Object.assign(this, {
            name: args.name,
            context: args.context,
            id: args.id,
            templateId: args.templateId,
            templateName: args.templateName,
            organizationId: args.organizationId,
            userId: args.userId,
            previousState: args.previousState,
            currentState: args.currentState,
            states: args.states,
            currentWorkItem: args.currentWorkItem,
            associatedWorkItems: args.associatedWorkItems,
            history: args.history,
            isPublic: args.isPublic,
            startAtSummary: args.startAtSummary,
            onBehalf: args.onBehalf != null && args.onBehalf,
            isReturned: args.isReturned != null && args.isReturned
        });
    }

    findCurrentState(): State {
        let state: State = this.states.find(s => s.name === this.currentState);

        if (!state) {
            throw new Error(`Cant find state current state for /${this.id}`);
        } else {
            return state;
        }
    }

    findInputForms(): State[] {
        return this.states.filter(s => s.stateType === StateType.InputForm);
    }

    isInReview(): boolean {
        const state = this.findCurrentState();
        return state.stateType === StateType.ReviewForm;
    }

    saveContext(): Observable<any> {
        return observableOf(this);
    }

    saveFullContext(): Observable<any> {
        return observableOf(this);
    }

    executeTransition(state: State, button: TransitionButton, transition: Transition): Promise<any> {
        return observableOf(this).toPromise();
    }

    returnWorkItem(workItem: WorkOrder): Promise<any> {
        return observableOf(this).toPromise();
    }

    completeWorkItem(workItem: WorkOrder): Promise<any> {
        return observableOf(this).toPromise();
    }

    gotoLocalTarget(state: State, transition: Transition): Promise<any> {
        console.log(`gotoLocalTarget ${transition.name} on ${state.name}`);
        return observableOf(this).toPromise();
    }
}

export class State {

    flow: FlowInstance;
    context: any;
    isInitial: boolean;
    isTerminal: boolean;
    key: number;
    name: string;
    sections: Section[];
    title: string;
    transitions: Transition[];
    stateType: StateType;
    constructor(args: {
        flow: FlowInstance,
        isInitial?: boolean,
        isTerminal?: boolean,
        name?: string,
        sections?: Section[]
        title?: string,
        transitions?: Transition[],
        stateType: StateType,
        key: number,
    }) {
        Object.assign(this, {
            flow: args.flow,
            isInitial: args.isInitial || false,
            isTerminal: args.isTerminal || false,
            name: args.name || "UNNAMED STATE",
            sections: args.sections,
            title: args.title || "UNNAMED STATE",
            transitions: args.transitions || [],
            stateType: args.stateType,
            key: args.key
        });
    }

    // saveContext(): Promise<any> {
    //     return this.flow.saveContext();
    // }

    findTransition(name: string): Transition {
        if (this.isTerminal || !this.transitions || this.transitions.length == 0)
            throw new Error("Cant execute transitions on a terminal state");
        return this.transitions.find(t => t.name == name);
    }

    // saveAndExecuteTransitionWithGoto(transition: Transition): Promise<any> {
    //     return this.saveContext().then(() => {
    //         this.executeTransition(transition)
    //             .then(() => {
    //                 return this.gotoLocalTarget(transition);
    //             });
    //     });
    // }
    // executeTransition(transition: Transition): Promise<any> {
    //     return this.flow.executeTransition(this, transition);
    // }
    gotoLocalTarget(transition: Transition): Promise<any> {
        return this.flow.gotoLocalTarget(this, transition);
    }

    totalPages(): number {
        let pages: number = 0;
        for (let s = 0; s < this.sections.length; s++) {
            pages = pages + this.sections[s].pages.length;
        }
        return pages;
    }
}

export class Transition {
    key: string;
    name: string;
    targetState: string;
    outgoingRules: ChangeTargetRule[] = [];
    sideEffects: SideEffect[] = [];

    constructor(args: {
        key?: string,
        name?: string,
        targetState?: string,
        outgoingRules?: ChangeTargetRule[],
        sideEffects?: SideEffect[],
    }) {
        Object.assign(this,
            {
                key: args.key || "",
                name: args.name || "UNNAMED TRANSITION",
                targetState: args.targetState || "UNNAMED TARGET STATE",
                outgoingRules: args.outgoingRules || [],
                sideEffects: args.sideEffects || [],
            });
        //nothing has a run-order
        if(this.sideEffects.filter(s=>s.runOrder === 0.0 || s.runOrder === null || s.runOrder === undefined).length == this.sideEffects.length){
            for(let i:number = 0; i<this.sideEffects.length; i++){
                this.sideEffects[i].runOrder = i+1;
            }
        }

    }
}

export class SideEffect {

    id: string;
    label: string;
    configuration: any;
    implementationType: SideEffectType;
    runOrder:number
    constructor(args: {
        id?: string,
        label: string,
        configuration: any,
        implmentationType: SideEffectType,
        runOrder:number
    }) {
        Object.assign(this, {
            id: args.id,
            label: args.label,
            configuration: args.configuration,
            implementationType: args.implmentationType,
            runOrder:args.runOrder || 0.0
        })
    }
}


export class ChangeTargetRule {
    rule: AsyncRuleEvaluationFn<any>;
    contextTarget: string;
    name: string;

    constructor(rule: AsyncRuleEvaluationFn<any>, contextTarget: string, name: string = "") {
        this.rule = rule;
        this.contextTarget = contextTarget;
        this.name = name;
    }
}

export class Section {
    id: string;
    name: string;
    isRequired: RuleEvaluationFn<boolean>;
    pages: Page[];

    constructor(args: {
        id? : string,
        name?: string,
        isRequired?: RuleEvaluationFn<boolean>,
        pages?: Page[];
        }) {
        Object.assign(this,
            {
                id: args.id,
                name: args.name,
                isRequired: args.isRequired || (() => false),
                pages: args.pages || []
        });
    }
}

export class Page {
    pageType: PageType;
    pageNumber: number;
    state: State;
    context: any;
    questions: Question[][];
    section: string;
    sectionTitle?: string;
    subtitle: string;
    buttons: Button[];
    navigationButtons: Button[];
    specialButtons: Button[];
    incomingRules: ChangeTargetRule[];
    isSectionHead: boolean;
    partiallyRequiredValid: RuleEvaluationFn<boolean>;

    constructor(args: {
        pageType? : PageType,
        pageNumber?: number,
        context?: any,
        state?: State,
        questions?: Question[][],
        section?: string,
        sectionTitle?: string,
        subtitle?: string,
        buttons?: Button[],
        incomingRules?: ChangeTargetRule[],
        isSectionHead?: boolean,
    }) {
        Object.assign(this, {
            pageType: args.pageType,
            pageNumber: args.pageNumber,
            state: args.state,
            questions: args.questions || [],
            section: args.section,
            sectionTitle: args.sectionTitle,
            subtitle: args.subtitle,
            buttons: args.buttons,
            incomingRules: args.incomingRules || [],
            isSectionHead: args.isSectionHead || false
        });
    }

    generateForm(partiallyRequired: boolean): FormGroup {

        let items = {};

        for (let r of this.questions) {
            for (let q of r) {
                items[q.key] = q.getFormControl(partiallyRequired);
            }
        }

        return new FormGroup(items);
    }
}

export interface RuleEvaluationFn<T> {
    (): T;
}
export interface AsyncRuleEvaluationFn<T> {
    (): Promise<T>;
}

export abstract class Button {
    public static _createMap: any = (() => {
        let r = {};
        r[ButtonKind.Transition] = () => new TransitionButton();
        r[ButtonKind.JumpToPage] = () => new PageJumpButton();
        r[ButtonKind.JumpToSection] = () => new SectionJumpButton();
        r[ButtonKind.Next] = () => new NextButton();
        r[ButtonKind.Back] = () => new BackButton();
        r[ButtonKind.Approve] = () => new ApproveButton();
        r[ButtonKind.Return] = () => new ReturnButton();
        r[ButtonKind.AddReviewer] = () => new AddReviewerButton();
        r[ButtonKind.UpdateWorkItem] = () => new UpdateWorkItemButton();
        return r;
    })();


    static create(type: ButtonKind, args: {
        id: string,
        section?: Section,
        page?: Page,
        label?: string,
        enabled?: RuleEvaluationFn<boolean>,
        visible?: RuleEvaluationFn<boolean>,
        notifyMessageRule: RuleEvaluationFn<string>,
        redirectToRule: RuleEvaluationFn<string>,
        targetTransition?: AsyncRuleEvaluationFn<string>,
        finalDestination?: RuleEvaluationFn<string>,
        targetPage?: AsyncRuleEvaluationFn<number>,
        targetSection? : AsyncRuleEvaluationFn<number>,
        position: ButtonPosition,
        special?: boolean,
        confirmAction?: boolean,
        restrictingGroups?: string[],
        alwaysEnable?: boolean
    }): Button {

        let button: Button = Object.assign(Button._createMap[type](), {
            id: args.id,
            label: args.label,
            section: args.section,
            page: args.page,
            enabled: args.enabled || (() => true),
            visible: args.visible || (() => true),
            notifyMessageRule: args.notifyMessageRule || (() => ''),
            redirectToRule: args.redirectToRule || (() => ''),
            position: args.position,
            special: args.special,
            confirmAction: args.confirmAction,
            restrictingGroups: args.restrictingGroups,
            alwaysEnable: args.alwaysEnable
        });

        button.initialize(args);
        return button;
    }
    id: string;
    confirmAction: boolean;
    special: boolean;
    section: Section;
    page: Page;
    enabled: RuleEvaluationFn<boolean>;
    visible: RuleEvaluationFn<boolean>;
    notifyMessageRule: RuleEvaluationFn<string>;
    redirectToRule: RuleEvaluationFn<string>;
    label: string;
    position: ButtonPosition;
    restrictingGroups: string[] = [];
    alwaysEnable: boolean;
    abstract type: ButtonKind;
    protected abstract initialize(args: any);
    get isTransition() {
        return false;
    }
    get isApprove() {
        return false;
    }
    get isReturn() {
        return false;
    }
    get isAddReviewer() {
        return false;
    }
    get isSpecial() {
        return this.special || this.isReturn || this.isApprove || this.isAddReviewer;
    }
    get isNavigation() {
        return !this.special && !this.isReturn && !this.isApprove && !this.isAddReviewer;
    }
    get isSectionJump() {
        return false;
    }
    get isNext() {
        return false;
    }
    get isPageJump() {
        return false;
    }
    get isBack() { return false; }
    get isUpdateWorkItem() { return false; }
}

export class AddReviewerButton extends Button {
    type = ButtonKind.AddReviewer;
    protected initialize(args) { }

    get isAddReviewer() {
        return true;
    }
}

export class ReturnButton extends Button {
    type = ButtonKind.Return;
    targetTransition: AsyncRuleEvaluationFn<string>;
    finalDestination: RuleEvaluationFn<string>;
    protected initialize(args: { finalDestination: RuleEvaluationFn<string> }) {
        this.finalDestination = args.finalDestination;
    }
    get isTransition() {
        return true;
    }
    get isReturn() {
        return true;
    }
}

export class ApproveButton extends Button {
    type = ButtonKind.Approve;
    targetTransition: AsyncRuleEvaluationFn<string>;

    protected initialize(args: any) {

    }
    get isTransition() {
        return true;
    }
    get isApprove() {
        return true;
    }
}

export class TransitionButton extends Button {
    type = ButtonKind.Transition;
    targetTransition: AsyncRuleEvaluationFn<string>;

    protected initialize(args: { targetTransition: AsyncRuleEvaluationFn<string> }) {
        this.targetTransition = args.targetTransition;
    }

    get isTransition() {
        return true;
    }
}

export class PageJumpButton extends Button {
    type = ButtonKind.JumpToPage;
    targetPage: AsyncRuleEvaluationFn<number>;
    get isPageJump() { return true; }
    protected initialize(args: { targetPage: AsyncRuleEvaluationFn<number> }) {

        this.targetPage = args.targetPage;

    }
}


export class BackButton extends PageJumpButton {
    type = ButtonKind.Back;
    get isBack() { return true; }
    get isPageJump() { return false; }

    public findPreviousPage(): number {
        //find the absolute index of the current page; decrement by 1
        let newPageIndex = 0;
        const sectionIndex = this.page.state.sections.findIndex(s => s === this.section);
        const pageIndex = this.section.pages.findIndex(p => p === this.page);
        for (let s = 0; s < this.page.state.sections.length && s < sectionIndex; s++) {
            newPageIndex = newPageIndex + this.page.state.sections[s].pages.length;
        }
        newPageIndex = newPageIndex + pageIndex - 1;
        return newPageIndex;
    }

    protected initialize(args: any) {
        this.targetPage = () => StaticPromise.from<number>(() => this.findPreviousPage());
    }

}


export class NextButton extends PageJumpButton {
    type = ButtonKind.Next;

    get isNext() { return true; }

    get isPageJump() { return false; }

    protected initialize(args: any) {
        this.targetPage = () => StaticPromise.from<any>(() => this.findNextPage());
    }

    public findNextPage(): number {
        //find the absolute index of the current page; increment by one

        let newPageIndex = 0;
        const sectionIndex = this.page.state.sections.findIndex(s => s === this.section);
        const pageIndex = this.section.pages.findIndex(p => p === this.page);
        for (let s = 0; s < this.page.state.sections.length && s < sectionIndex; s++) {
            newPageIndex = newPageIndex + this.page.state.sections[s].pages.length;
        }
        newPageIndex = newPageIndex + pageIndex + 1;
        return newPageIndex;
    }
}

export class SectionJumpButton extends Button {
    type = ButtonKind.JumpToSection;
    targetSection: AsyncRuleEvaluationFn<number>;

    get isSectionJump() {
        return true;
    }

    get isPageJump() {
        return true;
    }

    protected initialize(args: {  targetSection: AsyncRuleEvaluationFn<number> }) {
        this.targetSection = args.targetSection;
    }
}

export class UpdateWorkItemButton extends Button {
    type = ButtonKind.UpdateWorkItem;
    stateToSetWorkItemTo: WorkOrderStatus;

    constructor(workOrderStatusToSet: WorkOrderStatus = WorkOrderStatus.Pending)
    {
        super();
        this.stateToSetWorkItemTo = workOrderStatusToSet;
    }

    protected initialize(args) {
    }

    get isUpdateWorkItem() {
        return true;
    }
}


export interface QuestionValidationMessage {
    key: string;
    message: string;
}

export abstract class Question {
    config?: any;
    context: any;
    contextTarget: string;
    initialDataContextTarget: string;
    enabled: RuleEvaluationFn<boolean>;
    helpText: string;
    initialValue: AsyncRuleEvaluationFn<any>;
    key: string;
    label: string;
    type: QuestionKind;
    pageValidationMessages: QuestionValidationMessage[];
    pageValidator: AsyncValidatorFn;
    flowValidationMessages: QuestionValidationMessage[];
    flowValidator: AsyncValidatorFn;
    visible: AsyncRuleEvaluationFn<boolean>;
    changeRules: ChangeTargetRule[];
    files: Array<string> = new Array<string>();
    flexGrow: number = 1;
    defaultValue: any;

    protected abstract initialize(args: any): void;

  public static _questionCreatorMap: any = (() => {
    let r = {};
    r[QuestionKind.ButtonLink] = () => new ButtonLinkQuestion();
    r[QuestionKind.Textbox] = () => new TextEntryQuestion();
    r[QuestionKind.Combo] = () => new ComboQuestion();
    r[QuestionKind.Dropdown] = () => new DropDownQuestion();
    r[QuestionKind.Checkbox] = () => new CheckboxQuestion();
    r[QuestionKind.Radio] = () => new RadioQuestion();
    r[QuestionKind.Label] = () => new SimpleLabel();
    r[QuestionKind.ItemList] = () => new ItemList();
    r[QuestionKind.Group] = () => new GroupQuestion();
    r[QuestionKind.FileUpload] = () => new FileUploadQuestion();
    r[QuestionKind.TextArea] = () => new TextAreaQuestion();
    r[QuestionKind.Summary] = () => new SummaryQuestion();
      r[QuestionKind.NewCasingPlan] = () => new NewCasingPlanQuestion();
      r[QuestionKind.CasingPlanGrid] = () => new CasingPlanGridQuestion();
      r[QuestionKind.EditCasingPlan] = () => new EditCasingPlanQuestion();
      r[QuestionKind.PaymentCheckout] = () => new PaymentCheckoutQuestion();
      r[QuestionKind.PaymentResponse] = () => new PaymentResponseQuestion();
    r[QuestionKind.ReviewComments] = () => new ReviewCommentsQuestion();
	r[QuestionKind.YesNoToggle] = () => new YesNoToggleQuestion();
        r[QuestionKind.MultiselectCheckbox] = () => new MulitselectCheckboxQuestion();
	r[QuestionKind.ESignature] = () => new ESignatureQuestion();
    r[QuestionKind.Empty] = () => new EmptyQuestion();
    r[QuestionKind.ReportFooterDefault] = () => new ReportHeaderFooter();
    r[QuestionKind.ReportHeaderImage] = () => new ReportHeaderImage();
      r[QuestionKind.ReportHeaderDefault] = () => new ReportHeaderDefault();
      r[QuestionKind.PdfGenerator] = () => new PdfGenerator();
      r[QuestionKind.CertifiedMailLabelGenerator] = () => new CertifiedMailLabelGenerator();
      r[QuestionKind.ChiefsSignature] = () => new ChiefsSignatureQuestion();

      r[QuestionKind.ReportSelector] = () => new ReportSelectorQuestion();
      r[QuestionKind.ReportTemplateEditor] = () => new ReportTemplateEditorQuestion();
      r[QuestionKind.ReportPdfView] = () => new ReportPdfViewQuestion();
      r[QuestionKind.MapControl] = () => new MapControl();
      r[QuestionKind.RouteControl] = () => new RouteControl();
      r[QuestionKind.DataQueryButton] = () => new DataQueryButton();
      r[QuestionKind.PhoneInput] = () => new PhoneInput();
      r[QuestionKind.FlowDataTable] = () => new FlowDataTable();
      r[QuestionKind.AreaOfReviewMap] = () => new AreaOfReviewMap();
      r[QuestionKind.PdfViewer] = () => new PdfViewer();
      r[QuestionKind.DatePicker] = () => new DatePicker();
      r[QuestionKind.ListEntry] = () => new ListEntry();
      r[QuestionKind.CasingPlanSchematic] = () => new CasingPlanSchematic();
      r[QuestionKind.FileParser] = () => new FileParser();
      r[QuestionKind.BulkWellTransferParser] = () => new BulkWellTransferParser();
      return r;
  })();

    static create(type: QuestionKind, args: {
        context?: any;
        contextTarget?: string;
        initialDataContextTarget?: string;
        initialValue: RuleEvaluationFn<any>;
        enabled?: RuleEvaluationFn<boolean>;
        helpText?: string;
        key?: string;
        label?: string;
        pageValidationMessages?: QuestionValidationMessage[];
        pageValidator?: AsyncValidatorFn;
        flowValidationMessages?: QuestionValidationMessage[];
        flowValidator?: AsyncValidatorFn;
        visible?: RuleEvaluationFn<boolean>;
        changeRules?: ChangeTargetRule[],
        files?: Array<string>,
        flexGrow?: number,
        defaultValue?: any,
        config?: any
    } = null): Question {

        let argsv: any = args || {};
        let map = Question._questionCreatorMap;

        if (!map[type]) throw new Error(`Bad type ${type}`);

        let q = Object.assign(map[type](), {
            context: argsv.context || {},
            contextTarget: argsv.contextTarget || null,
            initialDataContextTarget: argsv.initialDataContextTarget || null,
            initialValue: argsv.initialValue,
            enabled: argsv.enabled || (() => true),
            helpText: argsv.helpText || null,
            key: argsv.key || "",
            label: argsv.label || "",
            pageValidationMessages: argsv.pageValidationMessages || [],
            pageValidator: argsv.pageValidator || (() => { }),
            flowValidationMessages: argsv.flowValidationmessages || [],
            flowValidator: argsv.flowValidator || (() => { }),
            visible: argsv.visible || (() => true),
            changeRules: args.changeRules || [],
            files: args.files || [],
            flexGrow: args.flexGrow || 1,
            defaultValue: args.defaultValue,
            config: args.config
        });

        q.initialize(args);
        return q;
    }



    getValue(): any {
        console.log(`getting ${this.key} from ${this.contextTarget}:`);
        let value = jp.value(this.context, this.contextTarget);
        console.log(`|__found value ${value}`)
        return value;
    }

    setValue(value: any) {
        console.log(`setting ${this.contextTarget} from ${this.key} to ${value}`);
        jp.value(this.context, this.contextTarget, value);
    }

    getFormControl(partiallyRequired: boolean): AbstractControl {
        const fn = (partiallyRequired) ? this.flowValidator : this.pageValidator;

        let control = new FormControl(this.defaultValue, [fn]);
        return control;
    }
}

export class EmptyQuestion extends Question {
    type = QuestionKind.Empty;

    protected initialize(args: any): void { }
}

export class TextEntryQuestion extends Question {
    type = QuestionKind.Textbox;
    protected initialize(args: any): void { }
}

export class ButtonLinkQuestion extends Question {
    type = QuestionKind.ButtonLink;
    protected initialize(args: any): void { }
}

export abstract class MultiOptionQuestion extends Question {

    contextOptionSource: string;

    protected initialize(args: { contextOptionSource: string }): void {
        this.contextOptionSource = args.contextOptionSource;
    }

    get options(): any {
        return jp.value(this.context, this.contextOptionSource);
    }
}

export class FileUploadQuestion extends Question {
    type = QuestionKind.FileUpload;

    protected initialize(args: any): void { }
}

export class TextAreaQuestion extends Question {
    type = QuestionKind.TextArea;

    protected initialize(args: any): void { }
}

export class ComboQuestion extends MultiOptionQuestion {
    type = QuestionKind.Combo;
}

export class DropDownQuestion extends MultiOptionQuestion {
    type = QuestionKind.Dropdown;
}

export class MulitselectCheckboxQuestion extends MultiOptionQuestion {
    type = QuestionKind.MultiselectCheckbox;
}

export class CheckboxQuestion extends Question {
    type = QuestionKind.Checkbox;
    protected initialize(args: any): void { }
}

export class YesNoToggleQuestion extends Question {
    type = QuestionKind.YesNoToggle;
    protected initialize(args: any): void { }
}


export class RadioQuestion extends MultiOptionQuestion {
    type = QuestionKind.Radio;
}

export class ESignatureQuestion extends Question {
    type = QuestionKind.ESignature;
    protected initialize(args: any): void { }
}

export class ChiefsSignatureQuestion extends Question {
    type = QuestionKind.ChiefsSignature;
    protected initialize(args: any): void { }
}

export class FlowDataTable extends Question {
    type = QuestionKind.FlowDataTable;

    protected initialize(args: any): void { }
}

export class PdfViewer extends Question {
    type = QuestionKind.PdfViewer;

    protected initialize(args: any): void { }
}

export class GroupQuestion extends Question {

    questions: Question[];
    type = QuestionKind.Group;

    protected initialize(args: { questions: Question[] }): void {
        this.questions = args.questions;
    }

    getValue(): any {
        throw new Error("Shouldn't hit this directly");
    }

    setValue(value: any) {
        throw new Error("Shouldn't hit this directly");
    }

    getFormControl(partiallyRequired: boolean): AbstractControl {

        let items = {};

        for (let r of this.questions) {
            items[r.key] = r.getFormControl(partiallyRequired);
        }

        return new FormGroup(items);
    }
}

export class SummaryQuestion extends Question {
    type = QuestionKind.Summary;
    protected initialize(args: any): void { }
}

export class NewCasingPlanQuestion extends Question {
    type = QuestionKind.NewCasingPlan;
    protected initialize(args: any): void { }
}

export class CasingPlanGridQuestion extends Question {
    type = QuestionKind.CasingPlanGrid;
    protected initialize(args: any): void { }
}

export class PaymentCheckoutQuestion extends Question {
    type = QuestionKind.PaymentCheckout;
    protected initialize(args: any): void { }
}

export class PaymentResponseQuestion extends Question {
    type = QuestionKind.PaymentResponse;
    protected initialize(args: any): void { }
}

export class EditCasingPlanQuestion extends Question {
    type = QuestionKind.EditCasingPlan;
    protected initialize(args: any): void { }
}

export class ReviewCommentsQuestion extends Question {
    type = QuestionKind.ReviewComments;
    protected initialize(args: any): void { }
}

export class SimpleLabel extends Question {
    type = QuestionKind.Label;
    protected initialize(args: any): void { }

}

export class ReportHeaderImage extends Question {
    type = QuestionKind.ReportHeaderImage;
    protected initialize(args: any): void { }
}

export class ReportHeaderFooter extends Question {
    type = QuestionKind.ReportFooterDefault;
    protected initialize(args: any): void { }
}

export class ReportHeaderDefault extends Question {
    type = QuestionKind.ReportHeaderDefault;
    protected initialize(args: any): void { }
}

export class ReportSelectorQuestion extends Question {
    type = QuestionKind.ReportSelector;
    protected initialize(args: any): void { }
}

export class ReportTemplateEditorQuestion extends Question {
    type = QuestionKind.ReportTemplateEditor;
    protected initialize(args: any): void { }
}


export class ReportPdfViewQuestion extends Question {
    type = QuestionKind.ReportPdfView;
    protected initialize(args: any): void { }
}
export class PdfGenerator extends Question {
    type = QuestionKind.PdfGenerator;
    protected initialize(args: any): void { }
}

export class CertifiedMailLabelGenerator extends Question {
    type = QuestionKind.CertifiedMailLabelGenerator;
    protected initialize(args: any): void { }
}

export class ItemList extends MultiOptionQuestion {
    type = QuestionKind.ItemList;
}

export class MapControl extends Question {
    type = QuestionKind.MapControl;

    protected initialize(args: any): void { }
}


export class RouteControl extends Question {
    type = QuestionKind.RouteControl;

    protected initialize(args: any): void { }
}

export class DataQueryButton extends Question {
    type = QuestionKind.DataQueryButton;

    protected initialize(args: any): void { }
}

export class PhoneInput extends Question {
    type = QuestionKind.PhoneInput;

    protected initialize(args: any): void { }
}

export class AreaOfReviewMap extends Question {
    type = QuestionKind.AreaOfReviewMap;

    protected initialize(args: any): void { }
}

export class DatePicker extends Question {
    type = QuestionKind.DatePicker;

    protected initialize(args: any): void { }
}

export class ListEntry extends Question {
    type = QuestionKind.ListEntry;

    protected initialize(args: any): void { }
}

export class CasingPlanSchematic extends Question {
    type = QuestionKind.CasingPlanSchematic;

    protected initialize(args: any): void { }
}

export class FileParser extends Question {
    type = QuestionKind.FileParser;

    protected initialize(args: any): void { }
}

export class BulkWellTransferParser extends Question {
    type = QuestionKind.BulkWellTransferParser;

    protected initialize(args: any): void { }
}

export interface PendingFlow extends FlowIndex {
    applicationNumber?: string;
    assigneeName?: string;
    currentWorkItemId?: string;
    dueDate?: Date;
    isExpedited?: string;
    targetUrl?: string;
    onBehalf?: boolean;
}

export interface PaymentReceivedDateRequest {
    applicationNumbers?: string[];
    flowInstanceIds?: string[];
    paymentReceivedDate?: Date;
    isElectronicPayment: boolean;
}